import { render, staticRenderFns } from "./address_dialog.vue?vue&type=template&id=47505de4"
import script from "./address_dialog.vue?vue&type=script&lang=js"
export * from "./address_dialog.vue?vue&type=script&lang=js"
import style0 from "./address_dialog.vue?vue&type=style&index=0&id=47505de4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports